// extracted by mini-css-extract-plugin
export default {"item":"Item_item","dropdownWrapper":"Item_dropdownWrapper","text":"Item_text"};